module.exports = __webpack_public_path__ + "img/motorsport.34c04cc9.svg";